import { gql } from 'graphql-request'
import { MoreHorizontal } from 'lucide-react'

import { useMutation } from '@hooks/graphql'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'

const UPDATE_AUTHORIZATION_ROLE_MUTATION = gql`
  mutation updateMembershipRole($input: UpdateRoleInput!) {
    updateMembershipRole(input: $input) {
      membership {
        role
      }
      errors {
        message
      }
    }
  }
`

const UPDATE_MEMBERSHIP_MUTATION = gql`
  mutation updateMembership($input: UpdateMembershipInput!) {
    updateMembership(input: $input) {
      membership {
        deactivated
      }
      errors {
        message
      }
    }
  }
`

const EducatorListActions = ({ id, email, fullName, role, deactivated, refetch }) => {
  const educatorNameOrEmail = fullName.trim() === '' ? email : fullName

  const { mutate: updateEducatorRole } = useMutation({
    gqlMutation: UPDATE_AUTHORIZATION_ROLE_MUTATION,
    onSuccess: refetch
  })

  const handleRoleChange = (id, newRole) => {
    updateEducatorRole({
      input: {
        profileId: id,
        role: newRole
      }
    })
  }

  const { mutate: updateMembership } = useMutation({
    gqlMutation: UPDATE_MEMBERSHIP_MUTATION,
    onSuccess: refetch
  })

  const handleArchiveToggle = (profileId, deactivated) => {
    updateMembership({
      input: {
        profileId,
        deactivated
      }
    })
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant='ghost' className='h-8 w-8 p-0'>
          <span className='sr-only'>Open menu</span>
          <MoreHorizontal className='h-4 w-4' />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='end'>
        <Choose>
          <When condition={role === 'ADMIN'}>
            <DropdownMenuItem onClick={() => handleRoleChange(id, 'EDUCATOR')}>
              Make {educatorNameOrEmail} an educator
            </DropdownMenuItem>
          </When>

          <Otherwise>
            <DropdownMenuItem onClick={() => handleRoleChange(id, 'ADMIN')}>
              Make {educatorNameOrEmail} an admin
            </DropdownMenuItem>
          </Otherwise>
        </Choose>

        <Choose>
          <When condition={deactivated}>
            <DropdownMenuItem onClick={() => handleArchiveToggle(id, false)}>
              Unarchive account
            </DropdownMenuItem>
          </When>
          <Otherwise>
            <DropdownMenuItem onClick={() => handleArchiveToggle(id, true)} className='text-red-500 focus:text-red-500 focus:bg-red-50 dark:focus:bg-red-700/10 dark:focus:text-red-400'>
              Archive account
            </DropdownMenuItem>
          </Otherwise>
        </Choose>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default EducatorListActions
